import React from 'react';

import LawnApplicationsChart from '~/components/data-vis/lawn-applications-chart';

import styles from '~/components/plans/bundles-page/applications-timeline.module.scss';

const ApplicationsTimeline = ({ climate, selectedBundle }) => {
  if (!climate) {
    return null;
  }

  const uniqueFeatures = selectedBundle?.features.reduce((acc, feature) => {
    if (feature?.icon && !acc.includes(feature?.icon)) {
      acc.push(feature.icon);
    }
    return acc;
  }, []);

  return (
    <section className={styles.applicationsTimelineSection}>
      <h3>{selectedBundle?.title} preview</h3>
      <p>
        Here's your plan at a glance. Plus, you'll get a My Plan checklist to
        make it extra easy.
      </p>

      <LawnApplicationsChart
        featuresList={uniqueFeatures}
        grassType={climate?.grassType}
        historicalData={climate?.averageMonthlyGrowthPotentialData}
        mainColor="var(--secondary-dark-color)"
        selectedBundleTitle={selectedBundle?.title}
        sourceEngine={selectedBundle?.sourceEngine}
      />
    </section>
  );
};

export default ApplicationsTimeline;
